<template>
  <div>
    <h5 class="text-center upper-text color-sysblue back-ground-grey p-2">
      MEDICAMENTOS QUE O RESIDENTE FEZ DEVOLUÇÃO
    </h5>
    <div class="text-center p-5" v-if="items.length == 0">0</div>
    <div class="received-return" v-for="(medicine, key) in items" :key="key">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h5 class="mb-0 check-text-center">
          {{ medicine.medicine_name }}
        </h5>
        <h6 class="legends worksansr mb-0 check-text-center">
          {{ medicine.medicine_active_ingredient }}
        </h6>
        <h6
          class="m-0"
          v-if="medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'"
        >
          CONTROLE ESPECIAL
        </h6>
      </div>
      <div
        class="col-md-12"
        v-for="(devolution, index) in medicine.medicines"
        :key="index"
      >
        <h6 class="worksansr check-text-center">
          FORMA DE PAGAMENTO
          <strong
            >{{ devolution.type == "MEDICINE" ? "MEDICAMENTO" : "DINHEIRO" }}
            <span v-if="devolution.type == 'MONEY'">
              R$ {{ formatValueOnKeyUp(devolution.value) }}</span
            >
          </strong>
        </h6>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
            <h6 class="check-text-center worksansr">
              DEVOLUÇÃO DE
              <strong
                >{{ devolution.resident_who_borrowed.name }}
                <span v-if="devolution.type == 'MEDICINE'">
                  -
                  {{ devolution.resident_who_borrowed.stock.name }}
                </span>
              </strong>
            </h6>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
            <h6 class="upper-text check-text-center worksansr">
              Total emprestado
              <strong>
                {{
                  `${devolution.total} ${medicine.unit_of_measurement_name} (S)`
                }}
              </strong>
            </h6>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
            <h6 class="upper-text check-text-center worksansr">
              PARA
              <strong>
                {{ devolution.resident_who_lent.name }}
                <span v-if="devolution.type == 'MEDICINE'">
                  -
                  {{ devolution.resident_who_lent.stock.name }}
                </span>
              </strong>
            </h6>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          <h6
            class="upper-text worksansr check-text-center mb-1"
            v-for="devolution_has_medicine in devolution.devolution_has_medicine"
            :key="devolution_has_medicine.id"
          >
            Devolução de
            {{
              `${devolution_has_medicine.quantity} ${medicine.unit_of_measurement_name} (S)`
            }}
            no dia {{ formatDate(devolution_has_medicine.created_at) }}
          </h6>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatValueOnKeyUp } from "../../../../lib/format";

export default {
  name: "MadeReturn",
  props: {
    items: Array,
  },
  methods: {
    formatDate,
    formatValueOnKeyUp,
  },
};
</script>
